import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import ListItem from '@material-ui/core/ListItem';
import ConflictListItem from './conflict-list-item';
import { fetchGroupEntityOverlaps } from '@actions/groups-actions';
import { detailStyles } from '@constants/mui-theme';
import DotmapsLoader from '@shared/dotmaps-loader';
import './conflict-list.scss';

const ConflictList = ({ conflictList, entity, onClick }) => {
  const dispatch = useDispatch();
  const overlaps = useSelector(state => state.groups.edit.overlaps);

  // Fetch overlaps on mount if not already loaded
  useEffect(() => {
    if (!overlaps || !overlaps[entity.id]) {
      dispatch(fetchGroupEntityOverlaps(entity.id));
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getNestedItems = entityId => {
    const conflicts = R.values(overlaps[entityId].conflicts);
    const conflictedEntities = conflicts.filter(item => conflictList.includes(item.id));
    return conflictedEntities.map(
      conflictEntity => (
        <ListItem
          key={`conflict-list-item-${conflictEntity.id}`}
          style={{
            ...detailStyles.conflictListItem.style,
            padding: '1rem 1rem 0 1rem',
            width: '100%',
            display: 'block'
          }}
        >
          <ConflictListItem
            mainEntity={overlaps[entityId].mainEntity}
            entity={conflictEntity}
            onClick={onClick}
          />
        </ListItem>
      )
    );
  };

  if (overlaps && overlaps[entity.id]) {
    return (
      <div styleName="conflict-list-container">
        {getNestedItems(entity.id)}
      </div>
    );
  }

  return (
    <ListItem style={{ justifyContent: 'center' }}>
      <div styleName="conflict-loader-container">
        <DotmapsLoader />
      </div>
    </ListItem>
  );
};

ConflictList.propTypes = {
  conflictList: PropTypes.array,
  entity: PropTypes.object,
  onClick: PropTypes.func
};

export default ConflictList;
